import { render, staticRenderFns } from "./PanelButton.vue?vue&type=template&id=636b6f86&scoped=true&"
import script from "./PanelButton.vue?vue&type=script&lang=js&"
export * from "./PanelButton.vue?vue&type=script&lang=js&"
import style0 from "./PanelButton.vue?vue&type=style&index=0&id=636b6f86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b6f86",
  null
  
)

export default component.exports